var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigGSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 517.47 801.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u56FE\\u5C42_1-2",
    fill: "#d5e1f4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "429.08 300.53 429.08 300.53 429.08 640.12 483.74 593.04 483.74 405.73 517.47 376.67 429.08 300.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 593.04 54.66 640.11 54.66 300.42 0 347.49 0 593.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.62 129.23 92.62 672.18 242.62 801.41 392.62 672.18 392.62 268.98 298.7 189.42 298.7 675.92 242.62 727.06 186.55 675.92 186.55 122.23 242.62 71.04 392.62 199.94 392.62 129.23 242.62 0 92.62 129.23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigGSilver);
export default __webpack_public_path__ + "static/media/big-g-silver.f35cfee84ed8ad7702ab83f9d891cc9b.svg";
export { ForwardRef as ReactComponent };